import { Table, TableBody, TableContainer, TableRow } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { AvatarCombustivel } from "../../../components/avatarCombustivel";
import { IndicadorFlat } from "../../../components/Indicador";
import { SmallestTableCell } from "../../../components/TableCell";
import { Venda, VendaMedidas } from "../../../models/venda";
import { DashPanel } from "../DashPanel";
import { KPIComparativo } from "../KPIComparativo";
import numeral from "numeral";

export interface PanelCombustiveisLucroProps {
  vendaCombustiveis: Venda[];
  vendaComparativo: Venda[];
  totaisCombustiveis: VendaMedidas;
  totaisComparativo: VendaMedidas;
}

function pivot(data: any) {
  var iter = function (pivoted: any, record: any) {
    for (var key in record) {
      if (!pivoted[key]) pivoted[key] = [];
      pivoted[key].push(record[key]);
    }
    return pivoted;
  };
  return data.reduce(iter, {});
}

export const PanelCombustiveisLucro = (props: PanelCombustiveisLucroProps) => {
  const vendaCombustiveisPivot = pivot(
    props.vendaCombustiveis.map((x) => {
      return {
        preco: x.mediaPreco,
        custo: x.custoMedioUnitario,
        lucro: x.lucroBrutoMedioUnitario,
        margemVenda: x.margemLucroMedia,
        margemCusto: x.margemCustoMedia,
      };
    }),
  );

  const getKeyDescription = (key: string) => {
    if (key === "preco") return "Preço";
    if (key === "custo") return "Custo";
    if (key === "lucro") return "Lucro";
    if (key === "margemVenda") return "%/Venda";
    if (key === "margemCusto") return "%/Custo";
  };

  return (
    <DashPanel title="Combustíveis Lucro">
      <Grid
        container
        justifyContent="space-between"
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingBottom: "16px",
        }}
      >
        <Grid item>
          <IndicadorFlat
            titulo="Faturamento"
            r$
            valor={props.totaisCombustiveis.totalLiquido}
            showDecimals={false}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.totalLiquido}
            valor={props.totaisComparativo.totalLiquido}
            format=",0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Custo Médio"
            r$
            valor={props.totaisCombustiveis.custoMedio}
            showDecimals={false}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.custoMedio}
            valor={props.totaisComparativo.custoMedio}
            format=",0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Lucro Bruto"
            r$
            valor={props.totaisCombustiveis.lucroBrutoMedio}
            showDecimals={false}
          >
            <KPIComparativo
              valorBase={props.totaisCombustiveis.lucroBrutoMedio}
              valor={props.totaisComparativo.lucroBrutoMedio}
              format=",0"
            />
          </IndicadorFlat>
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="space-between"
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingBottom: "16px",
        }}
      >
        <Grid item>
          <IndicadorFlat
            titulo="Preço Médio"
            r$
            valor={props.totaisCombustiveis.mediaPreco}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.mediaPreco}
            valor={props.totaisComparativo.mediaPreco}
            format=",0.00"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Margem Venda"
            valor={numeral(
              props.totaisCombustiveis.margemLucroMedia / 100,
            ).format("0 %")}
            showDecimals={false}
          />
          <KPIComparativo
            valorBase={props.totaisCombustiveis.margemLucroMedia / 100}
            valor={props.totaisComparativo.margemLucroMedia / 100}
            format="0 %"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Margem Custo"
            valor={numeral(
              props.totaisCombustiveis.margemCustoMedia / 100,
            ).format("0 %")}
          >
            <KPIComparativo
              valorBase={props.totaisCombustiveis.margemCustoMedia / 100}
              valor={props.totaisComparativo.margemCustoMedia / 100}
              format="0 %"
            />
          </IndicadorFlat>
        </Grid>
      </Grid>

      <TableContainer>
        <Table size="small" aria-label="custom pagination table">
          <TableBody>
            <TableRow key={"0"}>
              <SmallestTableCell variant="head"></SmallestTableCell>
              {props.vendaCombustiveis.map((row) => (
                <SmallestTableCell
                  key={row.sigla!}
                  variant="head"
                  align="right"
                >
                  <AvatarCombustivel
                    style={{ marginLeft: "auto" }}
                    size="small"
                    combustivelSigla={row.sigla!}
                  />
                </SmallestTableCell>
              ))}
            </TableRow>
            {Object.entries(vendaCombustiveisPivot).map(
              ([key, value]: [string, any]) => (
                <TableRow key={key}>
                  <SmallestTableCell>
                    {getKeyDescription(key)}
                  </SmallestTableCell>
                  {value.map((x: number, idx: number) => (
                    <SmallestTableCell key={idx} align="right">
                      {key.includes("margem") ? (
                        <>{numeral(x).format(",0")} %</>
                      ) : (
                        numeral(x).format(",0.00")
                      )}
                    </SmallestTableCell>
                  ))}
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </DashPanel>
  );
};
